import userFormValidationService from "../../../../../../shared/user/user.validation.service";

const dealerAddByTaxiFormValidationService = {
  validateFirstName: userFormValidationService.validateFirstName,
  validateLastName: userFormValidationService.validateLastName,
  validateEmail: userFormValidationService.validateEmail,
  validateUsername: userFormValidationService.validateUsername,
  validatePassword: userFormValidationService.validatePassword,
  validatePasswordRepeat: userFormValidationService.validatePasswordRepeat,
  validatePhoneNumber: userFormValidationService.validateMobile,
  validateAlternativePhoneNumber:
    userFormValidationService.validateAlternativeMobile,
};

export default dealerAddByTaxiFormValidationService;
